
<template>
  <div style="width:100%;height:100%;" class="mainMap" :id="zzMapId">
    <mapswitch></mapswitch>
  </div>
</template>
<script>
import Vue from 'vue'
import 'element-ui/lib/theme-chalk/index.css'
import './libs/index'
import * as turf from '@turf/turf'
import mapswitch from './map-switch/index'
import Popup from './map-popup/index'
Vue.use(Popup)

Vue.prototype.$event = Vue.prototype.$event || new Vue()
export default {
  name: 'mainMap',
  components: {
    mapswitch
  },
  props: {
    // 可以创建多个地图对象
    mapid: {
      type: String
    },
    isloadData: {
      type: Boolean,
      default: true
    },
    istoolbar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: true,
      zzMapId: this.mapid || 'mapDiv_' + Math.ceil(Math.random() * 10000),
      mapoptins: this.mapOptins,
      mainMap: null,
      mapNavbar: null,
      map_Center: [27.842398471, 113.154482025]
    }
  },
  created() {
    for (let i = 0; i < city.length; i++) {
      if (city[i].check === true) {
        this.map_Center = city[i].mapCenter
      }
    }
    this.$nextTick(() => {
      if (this.mapoptins === undefined) {
        this.mapoptins = {
          mapcrs: null,
          center: this.map_Center,
          zoomLevel: 12,
          zoomControl: true,
          visibleContextmenu: true

        }
      }
      if (this.zzMapId === undefined) this.zzMapId = 'mapDiv_' + Math.ceil(Math.random() * 10000)
      // 创建地图容器对象
      this.createMap(this.zzMapId, this.mapoptins)
      // 地图容器创建完成，触发initMapCompleteEvent事件
      this.$event.$emit('ready', this.mainMap)
    })
  },
  mounted() {
    //
  },
  methods: {
    createMap(mapDivid, mapOptins) {
      const c = Math.PI * 2 * 6378137
      const halfC = c / 2
      // eslint-disable-next-line camelcase
      const tdt_Mercator_resolutions = []
      for (let i = 1; i < 19; i++) {
        tdt_Mercator_resolutions.push(c / 256 / Math.pow(2, i))
      }
      // eslint-disable-next-line camelcase
      const TianDiTu_MercatorCRS = new L.Proj.CRS('EPSG:3857', '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs',
        {
          origin: [-halfC, halfC],
          resolutions: tdt_Mercator_resolutions,
          bounds: L.bounds([-halfC, -halfC], [halfC, halfC]),
          wrapLng: [-180, 180]
        })
      this.mainMap = L.map(mapDivid, {
        crs: TianDiTu_MercatorCRS, // TianDiTu_MercatorCRS,L.CRS.EPSG3857
        center: mapOptins.center,
        attributionControl: false,
        doubleClickZoom: false,
        closePopupOnClick: false,
        zoom: mapOptins.zoomLevel,
        maxZoom: 16,
        minZoom: 10,
        zoomControl: false,
        contextmenu: mapOptins.visibleContextmenu, // 地图右键
        contextmenuWidth: 140,
        contextmenuItems: mapOptins.contextmenuItemsAry
      })
      const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (flag) {
        L.control.zoom({
          position: 'bottomright'
        }).addTo(this.mainMap)
      } else {
        L.control.zoom({
          position: 'topleft'
        }).addTo(this.mainMap)
      }

      const resultHighlightLayerGroup = L.featureGroup().addTo(this.mainMap)
      this.mainMap.resultHighlightLayerGroup = resultHighlightLayerGroup

      const resultLayerGroup = L.featureGroup().addTo(this.mainMap)
      this.mainMap.resultLayerGroup = resultLayerGroup

      const landLayerGroup = L.featureGroup().addTo(this.mainMap)
      this.mainMap.landLayerGroup = landLayerGroup

      const landMarkerLayerGroup = L.featureGroup().addTo(this.mainMap)
      this.mainMap.landMarkerLayerGroup = landMarkerLayerGroup

      const searchAroundLayerGroup = L.featureGroup().addTo(this.mainMap)
      this.mainMap.searchAroundLayerGroup = searchAroundLayerGroup

      const poisLayerGroup = L.featureGroup().addTo(this.mainMap)
      this.mainMap.poisLayerGroup = poisLayerGroup

      const navbar = L.control.navbar().addTo(this.mainMap)
      this.mapNavbar = navbar
      this.mainMap.invalidateSize(true)
      this.includeMethods()
    },
    includeMethods() {
      const _seft = this
      L.Map.include({
        sethighlightLayer(queryItem, isfitBounds) {
          let highlightLayer = null
          _seft.mainMap.resultHighlightLayerGroup.clearLayers()
          if (queryItem.feature.geometry.type === 'Point') {
            const pulsingIcon = L.icon.pulse({ iconSize: [15, 15], color: 'red' })
            let latlng = null
            latlng = [queryItem.feature.geometry.coordinates[1], queryItem.feature.geometry.coordinates[0]]
            highlightLayer = L.marker(latlng, { icon: pulsingIcon, zIndexOffset: -1000 })
            _seft.mainMap.resultHighlightLayerGroup.addLayer(highlightLayer)
            return highlightLayer
          }

          clearTimeout(_seft._t)
          highlightLayer = L.geoJSON(queryItem.feature, {
            style: { color: 'rgb(27, 255, 198,0.8)' }
          })
          const bounds = highlightLayer.getBounds()
          _seft.mainMap.resultHighlightLayerGroup.addLayer(highlightLayer)
          if (isfitBounds === true) {
            _seft.mainMap.fitBounds(bounds, { maxZoom: 15 })
          }
          _seft.highlightLayer(highlightLayer)
        },
        showMyPopup(map, latlng, params) {
          map.closePopup()
          const content = _seft.$popup(params)
          // eslint-disable-next-line
        var popup = L.popup({
            maxWidth: 379,
            offset: L.point(2, -2)
          })
            .setLatLng(latlng)
            .setContent(content.outerHTML)
            .openOn(map)
        },
        fullMap(e) {
          if (_seft.mapNavbar !== null && _seft.mapNavbar !== undefined) {
            _seft.mapNavbar._goHome()
          }
        }
      })
      L.Circle.include({
        toGeoJSON (precision) {
        // eslint-disable-next-line no-undef
          return turf.circle(turf.point([this._latlng.lng, this._latlng.lat]), this.getRadius(), { units: 'meters' })
        }
      })
      L.FeatureGroup.include({
        addLabel(latlng, text, style = {fontSize: '16px', fontColor: 'transparent', textShadow: '0px 0px 2px #333'}) {
          let len = 0
          if (text) {
            len = text.length * 9 - 10
          }
          const icon = L.divIcon({
            iconSize: ['auto', 22],
            iconAnchor: [len, 0],
            popupAnchor: [0, 0],
            className: 'caseNamelabel',
            html: `<span style="white-space:nowrap;font-size:${style.fontSize};color:${style.fontColor};font-weight:bold;-webkit-text-stroke: 0.8px #2e2b2b;-webkit-text-fill-color: #fff;">${text}</span>`
          })
          return L.marker(latlng, {icon}).addTo(this)
        }
      })
    },
    highlightLayer(graphic) {
      const t1 = window.setInterval(() => {
        graphic.setStyle({
          fillColor: '#00FFCC', // graphic.options.style.color,
          fillOpacity: 1
        })
        setTimeout(() => {
          graphic.setStyle({
            fillColor: '#00FFFF',
            fillOpacity: 0.2
          })
        }, 300)
      }, 800)
      setTimeout(() => {
        window.clearInterval(t1)
      }, 5000)
      return t1
    },
    zzMapZoomIn(e) {
      this.mainMap.zoomIn()
    },
    zzMapZoomOut(e) {
      this.mainMap.zoomOut()
    },
    cancelCur() {
      this.mainMap
        .off('click', this._mousedown, this)
        .off('mousedown', this._mousedown, this)
        .off('mousemove', this._mousemove, this)
        .off('mouseup', this._mouseup, this)
      const className = ''
      const mapDiv = document.getElementsByClassName('mainMap')
      if (mapDiv.length === 0) return
      for (let index = 0; index < mapDiv.length; index++) {
        const item = mapDiv[index]
        let classListArr = item.classList.value.split(' ')
        classListArr = classListArr.filter(e => e.indexOf('cursor') === -1)
        item.classList.value = classListArr.join(' ')
        className && item.classList.add(className)
      }
    },
    fullMap(e) {
      if (this.mapNavbar !== null) {
        this.mapNavbar._goHome()
      }
    },
    previewMap(e) {
      if (this.mapNavbar !== null) {
        this.mapNavbar._goFwd()
      }
    },
    backViewMap(e) {
      if (this.mapNavbar !== null) {
        this.mapNavbar._goBack()
      }
    },
    clearMap(e) {
      this.mainMap
        .off('click', this._mousedown, this)
        .off('mousedown', this._mousedown, this)
        .off('mousemove', this._mousemove, this)
        .off('mouseup', this._mouseup, this)
      this.mainMap.setView(this.mainMap.getCenter())
      this.mainMap.drawPloatFeatureGroup.clearLayers()
    },
    _mousedown(e) {
      if (!this.mainMap.options.crs) {
        Message.error('坐标系未定义！')
        return
      }
      this.mainMap.dragging.disable()
      this.center = e.latlng
      this.mainMap.on('mousemove', this._mousemove, this)
    },
    _mousemove(e) {
      this.radius = this.mainMap.options.crs.distance(this.center, e.latlng)
      this.destory()
      this.feature = L.circle(this.center, this.radius, this.options).addTo(this.layer)
      if (this.options.measureParams) {
        this.measurement.show()
      }
      this.mainMap.off('mousedown', this._mousedown, this).on('mouseup', this._mouseup, this)
      console.log('asdas')
    },
    _mouseup(e) {
      this.mainMap.off('mousemove', this._mousemove, this).off('mouseup', this._mouseup, this)
      this.mainMap.dragging.enable()
      this.finishedCallback && this.finishedCallback(this.feature, this.layer)
    }
  }
}
</script>

<style scoped>
.mainMap {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: default;
  position: relative;
}
.cursor-draw {
  cursor: url('./cur/draw.cur'), auto !important;
}

.cursor-identify {
  cursor: url('./cur/identify.cur'), auto !important;
}

.cursor-measure {
  cursor: url('./cur/measure.cur'), auto !important;
}

.cursor-zoomout {
  cursor: url('./cur/zoomout.cur'), auto !important;
}

.cursor-zoomin {
  cursor: url('./cur/zoomin.cur'), auto !important;
}

.cursor-pan {
  cursor: url('./cur/pan_over.cur'), auto !important;
}
</style>
